import {trackPromise} from "react-promise-tracker";
import {AdminApi} from "../service";

const PREFIX = 'belongings'

export async function getCapitals() {
  return await trackPromise(AdminApi.get(`${PREFIX}`).then((resp) => resp.data));
}